import { Container } from "./styles"

interface ResponseViewerRootProps {
	children: React.ReactNode
}

export const ResponseViewerRoot = ({ children }: ResponseViewerRootProps) => {
	return <Container style={{ overflowX: "scroll" }}>{children}</Container>
}
